import bs58 from "bs58";
import { isAddress } from "viem";

/** A Solana address is a base58 encoded 32 byte ed25519 public key. */
export function isSolanaAddress(value: string): boolean {
  const trimmed = value.trim();
  if (trimmed.length < 32 || trimmed.length > 44) return false;
  try {
    return bs58.decode(trimmed).length === 32;
  } catch {
    return false;
  }
}

export function isEvmAddress(value: string): boolean {
  return isAddress(value.trim(), { strict: false });
}
